module.exports = __webpack_public_path__ + "static/img/code.2d27033.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/code.png
// module id = BZph
// module chunks = 1